import React, { useEffect, useState } from 'react';
import { CustomVideoPlayer } from '@room-match/shared-ui-components';
import { VideoItemCont } from './MediaItem.styles';
import { uploadService } from 'shared/services/uploadService';

interface Props {
  src: string;
  mediaId?: string;
  thumbnail?: string;
}

const { getSingleMedia } = uploadService();

const VideoItem: React.FC<Props> = ({ src, mediaId, thumbnail: thumb }) => {
  const { data, isLoading } = getSingleMedia(mediaId || '');
  const [thumbnail, setthumbnail] = useState('');

  useEffect(() => {
    const str: string = data ? data : '';
    if (data && !thumb) {
      setthumbnail(`https://px-public-dev.s3.us-west-1.amazonaws.com/${str.split('/')[3]?.split('?')[0]}.0000000.jpg`);
    }
  }, [data, isLoading, thumb]);

  useEffect(() => {
    if (thumb) setthumbnail(thumb);
  }, [thumb]);

  return (
    <VideoItemCont>
      <div style={{ flex: 1, height: 214, borderRadius: 10 }}>
        <CustomVideoPlayer
          isSmall
          classes={{ root: 'profile-video-item', videoPlayer: '', icon: '' }}
          url={`${src}?redirect=false`}
          // thumbnail={thumbnail}
        />
      </div>
    </VideoItemCont>
  );
};

export default VideoItem;
